module.exports = __webpack_public_path__ + "img/24.b30e96f4.jpg";